/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import GiftCard from 'components/shared/reward/giftcard/giftcard';



/* ========== ~~~~~~~~~~ GIFT CARD : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentData, contentStatus, settings, queueStatus }, { contentId }) => ({
    frameData: !!contentId ? contentData[contentId].data[contentStatus[contentId].frame] : null,
    currentContentStatus: !!contentId ? contentStatus[contentId] : null,
    currentContentSettings: !!contentId ? settings.contentSettings[contentId] : null,
    contentId,
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
  mapStateToProps
)(GiftCard);
